import studentLimitExceededComponent from './limit-exceeded.component';


export default angular
  .module('fizyweb.paycell.student.limitExceeded', [])
  .component('limitExceeded', studentLimitExceededComponent).name;



// WEBPACK FOOTER //
// src/app/components/student/limit-exceeded/limit-exceeded.module.ts